import React from 'react';
import pt from 'prop-types';
import { StorefrontEditorSidebarIcon } from 'components/storefront/editor/icon';
import StorefrontEditorPage from 'components/storefront/editor/sidebar/page';

import './sidebar.scss';

export default class StorefrontEditorPageList extends React.PureComponent {
  static propTypes = {
    label: pt.string.isRequired,
    pages: pt.array.isRequired,
    selectedPage: pt.object,
    allowAdding: pt.bool,
    addLabel: pt.string,
    onClickAddPage: pt.func,
    onClickPage: pt.func,
    onClickPageGroup: pt.func,
  };

  renderPages() {
    const { pages, selectedPage, onClickPage, onClickPageGroup } = this.props;

    return pages.map((page) => (
      <StorefrontEditorPage
        key={page.id}
        page={page}
        selectedPage={selectedPage}
        onClickPage={onClickPage}
        onClickPageGroup={onClickPageGroup}
      />
    ));
  }

  renderAddPageButton() {
    const {
      allowAdding = false,
      addLabel = 'New page',
      onClickAddPage,
    } = this.props;

    if (!allowAdding) {
      return null;
    }

    return (
      <button
        className="storefront-editor--button-add"
        type="button"
        onClick={onClickAddPage}
      >
        <StorefrontEditorSidebarIcon type="plus-circle" />
        {addLabel}
      </button>
    );
  }

  render() {
    const { label } = this.props;

    return (
      <>
        <div className="storefront-editor--page-list">
          <span className="storefront-editor--page-list--label">{label}</span>
          <div className="storefront-editor--page-list--pages">
            {this.renderPages()}
            {this.renderAddPageButton()}
          </div>
        </div>
      </>
    );
  }
}
